import { render, staticRenderFns } from "./UpcomingAlertView.vue?vue&type=template&id=74d9aab2&"
import script from "./UpcomingAlertView.vue?vue&type=script&lang=js&"
export * from "./UpcomingAlertView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports